import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { paths } from '@/app/routes/paths';
import { isGuardianPortalOnly, useAuthStore } from '@/store';

/** Defense-in-depth: guardian-only users always return to portal dashboard. */
export function RedirectGuardianToDashboard({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);

  if (user && isGuardianPortalOnly(user)) {
    return <Navigate to={paths.guardianDashboard} replace />;
  }

  return children;
}
